import moment from 'moment'

const invalidDateText = 'Invalid date'

export const validateRPFileType = (fileName: string, allowedFileExtensions: string[]): boolean => {
  if (!fileName) return false
  const fileExtension = fileName.split('.').pop()?.toUpperCase() || ''
  const isFileTypeValid = allowedFileExtensions.includes(fileExtension)
  return isFileTypeValid
}

export const validateRPFileName = (fileName: string): boolean => {
  if (!fileName) return false
  //only accepts alphanumeric, international languages and  the following special characters: - _ = + [ ] { } ` ~ ; ' , . ! @ # $ % ^ & * ( )
  const regexPattern = /^[\p{L}\p{N}\-_=+\[\]{}`~;',.!@#$%^&*() ]*$/u
  return regexPattern.test(fileName)
}

export const formatRPDate = (sourceDate: Date | string | undefined | null): string => {
  if (!sourceDate || sourceDate === invalidDateText) return ''

  return moment(sourceDate).format('MM/DD/YYYY')
}
